import type { SxProps } from '@mui/material';

export enum CtaVariantsEnum {
  Primary = 'primary',
  Secondary = 'secondary',
  OutlinePrimary = 'outlinePrimary',
  OutlineSecondary = 'outlineSecondary',
}

export const CtaVariantStyles: Record<CtaVariantsEnum, SxProps> = {
  [CtaVariantsEnum.Primary]: {
    color: 'common.white',
    backgroundColor: 'primary.main',
    '&:hover': {
      backgroundColor: 'primary.dark',
    },
  },
  [CtaVariantsEnum.Secondary]: {
    color: 'common.white',
    backgroundColor: 'secondary.main',
    '&:hover': {
      backgroundColor: 'secondary.dark',
    },
  },
  [CtaVariantsEnum.OutlinePrimary]: {
    color: 'primary.main',
    backgroundColor: 'common.white',
    border: '1px solid',
    borderColor: 'primary.main',
    '&:hover': {
      color: 'primary.dark',
      border: '2px solid',
      borderColor: 'primary.dark',
    },
    '&:hover svg': {
      color: 'primary.dark',
    },
  },
  [CtaVariantsEnum.OutlineSecondary]: {
    color: 'secondary.main',
    backgroundColor: 'common.white',
    border: '1px solid',
    borderColor: 'secondary.main',
    '&:hover': {
      color: 'secondary.dark',
      border: '2px solid',
      borderColor: 'secondary.dark',
    },
    '&:hover svg': {
      color: 'secondary.dark',
    },
  },
};
